import { render, staticRenderFns } from "./PreFooter.vue?vue&type=template&id=8b2b4aac&scoped=true"
import script from "./PreFooter.vue?vue&type=script&lang=js"
export * from "./PreFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2b4aac",
  null
  
)

export default component.exports